"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _orm = _interopRequireDefault(require("./orm"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _default() {
  var initialState = _orm["default"].getEmptyState();

  var session = _orm["default"].mutableSession(initialState);

  var Group = session.Group,
      Row = session.Row,
      Item = session.Item;
  var group, row;
  group = Group.create({
    collapsed: false,
    position: 'chiara-home-banner1',
    title: 'Home Banner Position 1',
    exportedHTML: ''
  });
  row = Row.create({
    groupId: group.getId(),
    collapsed: false
  });
  Item.create({
    rowId: row.getId(),
    collapsed: false,
    type: 'banner',
    link: '#',
    'img': '//via.placeholder.com/1500x200',
    'imgHover': '//via.placeholder.com/1500x200',
    alt: '1500x200'
  });
  row = Row.create({
    groupId: group.getId(),
    collapsed: true
  });
  Item.create({
    rowId: row.getId(),
    collapsed: false,
    type: 'banner',
    link: '#',
    'img': '//via.placeholder.com/1500x600',
    'imgHover': '//via.placeholder.com/1500x600',
    alt: '1500x600'
  });
  row = Row.create({
    groupId: group.getId(),
    collapsed: true
  });
  Item.create({
    rowId: row.getId(),
    collapsed: false,
    type: 'banner',
    link: '#',
    'img': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner4.jpg?t=1534872902',
    'imgHover': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner4a.png?t=1534872903',
    alt: '747x496'
  });
  Item.create({
    rowId: row.getId(),
    collapsed: true,
    type: 'banner',
    link: '#',
    'img': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner5.jpg?t=1534872903',
    'imgHover': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner5a.png?t=1534872904',
    alt: '747x496'
  });
  row = Row.create({
    groupId: group.getId(),
    collapsed: true
  });
  Item.create({
    rowId: row.getId(),
    collapsed: false,
    type: 'banner',
    link: '#',
    'img': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner1.jpg?t=1534872898',
    'imgHover': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner1a.png?t=1534872899',
    alt: '496x496'
  });
  Item.create({
    rowId: row.getId(),
    collapsed: true,
    type: 'banner',
    link: '#',
    'img': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner2.jpg?t=1534872900',
    'imgHover': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner2a.png?t=1534872900',
    alt: '496x496'
  });
  Item.create({
    rowId: row.getId(),
    collapsed: true,
    type: 'banner',
    link: '#',
    'img': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner3.jpg?t=1534872901',
    'imgHover': 'https://cdn7.bigcommerce.com/s-g0pakqdzwl/product_images/uploaded_images/furniture-banner3a.png?t=1534872901',
    alt: '496x496'
  });
  row = Row.create({
    groupId: group.getId(),
    collapsed: true
  });
  Item.create({
    rowId: row.getId(),
    collapsed: false,
    type: 'banner',
    link: '#',
    'img': '//via.placeholder.com/1500x200',
    'imgHover': '//via.placeholder.com/1500x200',
    alt: '1500x200'
  });
  group = Group.create({
    collapsed: true,
    position: 'chiara-home-banner2',
    title: 'Home Banner Position 2',
    exportedHTML: ''
  });
  initialState.collapsed = false;
  return initialState;
}